import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProceduresListingState } from '@store/states/procedures-listing.state';

const featureSelector = createFeatureSelector<ProceduresListingState>('proceduresListing');

export const proceduresListingSelectors = {
  data: createSelector(featureSelector, (state) => state.data),
  error: createSelector(featureSelector, (state) => state.error),
  pagination: createSelector(featureSelector, (state) => state.pagination),
  type: createSelector(featureSelector, (state) => state.type),
  filters: createSelector(featureSelector, (state) => state.filters),
  hasFilters: createSelector(
    featureSelector,
    (state) =>
      Object.values(state.filters).filter((value) => (typeof value === 'string' ? !!value : !!value && value.length > 0)).length > 0
  ),
};
